import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c2ca42"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manualDiv0" }, null, -1 /* HOISTED */))
const _hoisted_4 = { style: {"display":"flex","justify-content":"left","width":"100%"} }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"manualDiv0\" data-v-07c2ca42></div><div style=\"width:100%;\" data-v-07c2ca42><table id=\"tblUserManual\" style=\"width:calc(100% - 16px);\" data-v-07c2ca42><thead data-v-07c2ca42><tr data-v-07c2ca42><th style=\"width:2%;\" data-v-07c2ca42>No.</th><th style=\"width:15%;\" data-v-07c2ca42>Name</th><th style=\"width:15%;\" data-v-07c2ca42>File</th><th style=\"width:10%;\" data-v-07c2ca42>Created Date</th><th style=\"width:10%;\" data-v-07c2ca42>Category</th><th style=\"width:22%;\" data-v-07c2ca42>Description</th><th style=\"width:7%;\" data-v-07c2ca42>Delete</th><th style=\"width:7%;\" data-v-07c2ca42>Edit</th><th style=\"width:12%;column-span:2;\" data-v-07c2ca42>Display Order</th></tr></thead></table></div>", 2)
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"center","height":"calc(96% - 200px)"}
}
const _hoisted_8 = {
  key: 1,
  id: "tblbodydiv",
  style: {"height":"calc(96% - 200px)","overflow":"auto"}
}
const _hoisted_9 = { id: "tblUserManual" }
const _hoisted_10 = { id: "tbltbody" }
const _hoisted_11 = { style: {"width":"2%"} }
const _hoisted_12 = { style: {"width":"15%"} }
const _hoisted_13 = { style: {"width":"15%"} }
const _hoisted_14 = { style: {"width":"10%"} }
const _hoisted_15 = { style: {"width":"10%"} }
const _hoisted_16 = { style: {"width":"22%"} }
const _hoisted_17 = { style: {"text-align":"center","width":"7%"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { style: {"text-align":"center","width":"7%"} }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  style: {"text-align":"center","width":"6%"}
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  style: {}
}
const _hoisted_24 = {
  key: 2,
  style: {"text-align":"center","width":"6%"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 3,
  style: {}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_28 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"35%","margin-left":"32.5%"}
}
const _hoisted_29 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_34 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"13px"}
}
const _hoisted_35 = { style: {"height":"370px"} }
const _hoisted_36 = { class: "row-div margin-bottom-20" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "Manual Name", -1 /* HOISTED */))
const _hoisted_38 = { class: "col-sm-7 errmsg" }
const _hoisted_39 = { class: "row-div margin-bottom-20" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "File", -1 /* HOISTED */))
const _hoisted_41 = { class: "fileUploaddiv" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position form-control lblselectButton-manual" }, "Select File", -1 /* HOISTED */))
const _hoisted_43 = { class: "col-sm-7 errmsg" }
const _hoisted_44 = { class: "row-div margin-bottom-20" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "Description", -1 /* HOISTED */))
const _hoisted_46 = { class: "col-sm-7 errmsg" }
const _hoisted_47 = { class: "row-div margin-bottom-20" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "Category", -1 /* HOISTED */))
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "col-sm-7 errmsg" }
const _hoisted_51 = { class: "modal-footer" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "modalCancel",
  class: "btn btn-secondary",
  style: {"width":"78px","height":"35px","text-align":"center"},
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "modalCancel",
  class: "btn btn-secondary",
  style: {"width":"78px","height":"35px","text-align":"center"},
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        "data-bs-toggle": "modal",
        "data-bs-target": "#showModal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.modalShow2())),
        class: "button-add"
      }, " Add Manual "),
      _createElementVNode("button", {
        class: "button-add",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addCategory()))
      }, " Maintain Category ")
    ]),
    _hoisted_5,
    ($setup.manualInfo.length == 0 && $setup.getData)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_7, " No data "))
      : ($setup.manualInfo.length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.manualInfo[0], (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    style: _normalizeStyle({ background: $setup.manualRowColoring(info.category, index) })
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(index + 1), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(info.name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(info.fileName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(info.createdDate), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(info.category), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(info.description), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "btn btn-primary button-design-scanManual",
                        onClick: ($event: any) => ($setup.deleteManualList(info.id, index))
                      }, " Delete ", 8 /* PROPS */, _hoisted_18)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("a", {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#showModal",
                        onClick: ($event: any) => ($setup.modalShow1(info)),
                        class: "btn btn-primary button-design-scanManual"
                      }, " Edit ", 8 /* PROPS */, _hoisted_20)
                    ]),
                    (index + 1 < $setup.manualInfo[0].length && info.category == $setup.manualInfo[0][index + 1].category)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                          _createElementVNode("button", {
                            class: "btn btn-primary button-design-scanManual",
                            onClick: ($event: any) => ($setup.manualMoveUpDown(index, 'Down'))
                          }, " Down ", 8 /* PROPS */, _hoisted_22)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_23)),
                    (index - 1 >= 0 && info.category == $setup.manualInfo[0][index - 1].category)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                          _createElementVNode("button", {
                            class: "btn btn-primary button-design-scanManual",
                            onClick: ($event: any) => ($setup.manualMoveUpDown(index, 'Up'))
                          }, " Up ", 8 /* PROPS */, _hoisted_25)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_26))
                  ], 4 /* STYLE */))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
    _hoisted_27,
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h5", _hoisted_32, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "textbox",
                    class: "adjusting-position form-control input-item",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.manualName) = $event)),
                    maxlength: "255"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.manualName]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString($setup.errManualName), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("input", {
                    type: "file",
                    id: "inputFile",
                    class: "d-none",
                    onChange: $setup.selectFile,
                    onClick: _cache[3] || (_cache[3] = (e) => {
        e.target.value = '';
      }
      )
                  }, null, 32 /* HYDRATE_EVENTS */),
                  _createElementVNode("button", {
                    class: "adjusting-position form-control w-100 p-0",
                    style: {"display":"flex"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectFileButton()))
                  }, [
                    _hoisted_42,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      disabled: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.fileName) = $event)),
                      class: "adjusting-position form-control txtselectFile-manual"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.fileName]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_43, _toDisplayString($setup.errContent), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "textbox",
                    class: "adjusting-position form-control input-item",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.description) = $event)),
                    maxlength: "255"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.description]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString($setup.errDescription), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: "adjusting-position form-select input-item",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.categoryInfoName) = $event)),
                    value: "checked",
                    id: "pullCategory"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoryInfo, (categoryData, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "adjusting-option",
                        key: index,
                        value: categoryData.category
                      }, _toDisplayString(categoryData.category), 9 /* TEXT, PROPS */, _hoisted_49))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.categoryInfoName]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString($setup.errCategoryName), 1 /* TEXT */)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            ($setup.modalSubject[0] == 'Edit Manual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("button", {
                    type: "button",
                    id: "btnUpdate",
                    class: "btn btn-primary button-design",
                    style: {"width":"78px","height":"35px","text-align":"center"},
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateManualList()))
                  }, " Update ")
                ]))
              : _createCommentVNode("v-if", true),
            ($setup.modalSubject[0] == 'Add New Manual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("button", {
                    type: "button",
                    id: "btnadd",
                    class: "btn btn-primary button-design",
                    style: {"width":"78px","height":"35px","text-align":"center"},
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.addManualList()))
                  }, " Add ")
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}